import { PropsWithChildren } from 'react';

import classNames from 'classnames';
import flattenChildren from 'react-keyed-flatten-children';

import context from '@/styles/contexts.module.scss';

import styles from './styles.module.scss';

export function BottomWarningsContainer({ children }: PropsWithChildren) {
  if (!children || !flattenChildren(children).length) {
    return;
  }

  return (
    <div className={styles.warnings}>
      <div className={classNames(context.light, styles.warningsBanner)}>{children}</div>
    </div>
  );
}
